// cSpell:disable

import '../_helpers/globalDate'
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD52ewkyMaSGkOB-Eq9u8Uf2QtSfDCfCh4',
  authDomain: 'championfan-production.firebaseapp.com',
  projectId: 'championfan-production',
  storageBucket: 'championfan-production.firebasestorage.app',
  messagingSenderId: '236582723954',
  appId: '1:236582723954:web:183b2b6de601f0c9437deb',
  measurementId: 'G-3H84HJYN2R',
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)

/* cSpell:enable */
